import { AccountSelectors } from '@core/account-data';
import { createSelectorDeepEqual } from '@core/ngrx-legacy';

export const accountCreatedAt = createSelectorDeepEqual(
  AccountSelectors.currentCompany,
  company => company?.createdAt,
);
